import React from 'react';
import { Home, Tag, BookOpen, Users } from 'lucide-react';
export function IntentLinks() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-118">
      <h2 className="text-2xl font-serif text-brand-dark mb-6 text-center" data-id="element-119">
        How can Krystle help?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-120">
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-121">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-122">
            <Tag size={22} data-id="element-123" />
          </div>
          <div data-id="element-124">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-125">
              Selling a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-126">
              Inland Empire seller specialist · Five Star Agent
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-127">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-128">
            <Home size={22} data-id="element-129" />
          </div>
          <div data-id="element-130">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-131">
              Buying a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-132">
              Redlands, Yucaipa, Highland & beyond
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-133">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-134">
            <BookOpen size={22} data-id="element-135" />
          </div>
          <div data-id="element-136">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-137">
              Real Estate Planning
            </p>
            <p className="text-sm text-brand-muted" data-id="element-138">
              Certified Real Estate Planner — long-term strategy
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-139">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-140">
            <Users size={22} data-id="element-141" />
          </div>
          <div data-id="element-142">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-143">
              Join Our Team
            </p>
            <p className="text-sm text-brand-muted" data-id="element-144">
              Interested in joining the Roth Real Estate Group?
            </p>
          </div>
        </a>
      </div>
    </section>;
}